import { render, staticRenderFns } from "./InfoMaterial.vue?vue&type=template&id=0a823595"
import script from "./InfoMaterial.vue?vue&type=script&lang=js"
export * from "./InfoMaterial.vue?vue&type=script&lang=js"
import style0 from "./InfoMaterial.vue?vue&type=style&index=0&id=0a823595&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports